import { render, staticRenderFns } from "./WrongServiceCartModal.vue?vue&type=template&id=4a8e864e&scoped=true&"
import script from "./WrongServiceCartModal.vue?vue&type=script&lang=ts&"
export * from "./WrongServiceCartModal.vue?vue&type=script&lang=ts&"
import style0 from "./WrongServiceCartModal.vue?vue&type=style&index=0&id=4a8e864e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e864e",
  null
  
)

export default component.exports